var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFE5A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0106 24.2533L12.2633 21.5059L8.73233 25.0307L8.49507 24.7901C8.36463 24.6578 8.25781 24.5424 8.25781 24.5338C8.25781 24.5251 9.15898 23.6169 10.2604 22.5154L12.263 20.5129L17.7687 26.0185L23.2747 20.5125L23.7704 21.0097L20.7749 24.005C19.1275 25.6525 17.7745 27.0003 17.7684 27.0003C17.7623 27.0003 16.5211 25.764 15.0102 24.253L15.0106 24.2533ZM15.6063 20.535V19.1226H14.5471V13.4736H15.6063V10.649H16.3126V13.4737H17.3718V19.1228H16.3126V21.9474H15.6063V20.535ZM9.95726 14.8859V13.4736H8.89804V7.8245H9.95726L9.95741 6.41233V5H10.6637V7.82465H11.7229V13.4737H10.6637V16.2984H9.95741L9.95726 14.8859ZM21.2554 14.8859V13.4736H20.1962V7.8245H21.2554L21.2556 6.41233V5H21.9618V7.82465H23.0211V13.4737H21.9618V16.2984H21.2556L21.2554 14.8859Z",
    fill: "#093851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.a00089e2965fa7081adc3d695a4178de.svg";
export { ForwardRef as ReactComponent };